/**
 * Proyeksiya qayta qurilishini kutayotgan kunni qayta so'rash oralig'i.
 *
 * ⚠️ 2 sekund — worker jobni deyarli darhol oladi, ya'ni odatda bir-ikki
 * urinishda yakunlanadi. Poll faqat drawer OCHIQ turganda ishlaydi
 * (`useAttendanceDay` `enabled: id !== null`), shuning uchun tabiiy chegarasi
 * bor va alohida urinishlar hisoblagichi kerak emas.
 */
export const RECOMPUTE_POLL_MS = 2000;

/**
 * `refetchInterval` qarori: `computedAt` hali bazaviy qiymatda bo'lsa poll
 * qilinadi, o'zgargan bo'lsa to'xtaydi.
 *
 * `baseline` bo'lmasa (tuzatish yuborilmagan) — poll YO'Q.
 */
export function recomputePollInterval(
	baseline: string | undefined,
	computedAt: string | undefined
): number | false {
	if (baseline === undefined) {
		return false;
	}

	// Ma'lumot hali kelmagan — javob kelguncha poll ochiq qoladi.
	if (computedAt === undefined) {
		return RECOMPUTE_POLL_MS;
	}

	return computedAt === baseline ? RECOMPUTE_POLL_MS : false;
}
